export const PAPER_FILE_SIZE = {
  A4: { width: '210mm', height: '297mm' },
};
